const loadGTM = () => {
  if (process.env.IPOS_ENV !== 'production' || window.__gtmLoaded) {
    return;
  }
  window.__gtmLoaded = true;

  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-TTK46RW');
};

const loadCallpage = () => {
  if (process.env.IPOS_ENV === 'local' || window.__callpageLoaded) {
    return;
  }
  window.__callpageLoaded = true;

  const __cp = { id: 'YPICHMDGk1rsPHuTwZrK6BqfQgqN6gnqvaJQwDgyXS4', version: '1.1' };

  const cp = document.createElement('script');
  cp.type = 'text/javascript';
  cp.async = true;
  cp.src = '++cdn-widget.callpage.io+build+js+callpage.js'
    .replace(/[+]/g, '/')
    .replace(/[=]/g, '.');
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(cp, s);

  if (window.callpage) {
    return;
  }

  window.callpage = function(...args) {
    const method = args[0];
    if (method === '__getQueue') {
      return this.methods;
    }
    if (method) {
      if (typeof window.callpage.execute === 'function') {
        return window.callpage.execute.apply(this, args);
      }
      (this.methods = this.methods || []).push({ arguments: args });
    }
  };
  window.callpage.__cp = __cp;
  window.callpage('api.button.autoshow');
  window.callpage('event.onReady', () => {
    const elCP = document.querySelector("#callpage div[data-test='widget-button-section']");
    if (elCP) {
      elCP.style.cssText =
        'top: var(--callpage-top) !important; left: var(--callpage-left) !important;';
    }
  });
};

let thirdPartyLoaded = false;

const loadThirdParty = () => {
  if (thirdPartyLoaded) {
    return;
  }
  thirdPartyLoaded = true;
  loadGTM();
  loadCallpage();
};

exports.onClientEntry = () => {
  const events = ['scroll', 'click', 'keydown', 'touchstart', 'mousemove'];
  events.forEach(event => {
    window.addEventListener(event, loadThirdParty, { once: true, passive: true });
  });

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadThirdParty, { timeout: 4000 });
  } else {
    setTimeout(loadThirdParty, 4000);
  }
};
